import React, { useContext, useEffect, useState } from 'react';
import { ChromePicker } from 'react-color';
import { Button, Dimmer, Grid, Loader } from 'semantic-ui-react';
import { getAppearanceData, UpdateAppearance } from '../../hooks/useAppearance';
import UploadImage from "../Shared/UploadImage";
import AuthContext from '../../contexts/AuthContext';

function Appearance() {
    
    const [backgroundColour, setBackgroundColour] = useState<string>("#13688E");
    const [backgroundDisplay, setBackgroundDisplay] = useState<boolean>(false);
    const [fontColour, setFontColour] = useState<string>("#FFFFFF");
    const [fontDisplay, setFontDisplay] = useState<boolean>(false);
    const [logo, setLogo] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);

    const { auth } = useContext(AuthContext);

    
    useEffect(() => {
        async function getData() {
            await getAppearanceSettings();
        }
        getData();
    }, [])

    const getAppearanceSettings = async () => {
        let data = await getAppearanceData(auth);

        setBackgroundColour(data.backgroundColour);
        setFontColour(data.fontColour);
        setLogo(data.logo);
        setLoading(false);
    }

    const saveSettings = async () => {
        const appearanceSettings = {
			Logo: logo,
			BackgroundColour: backgroundColour,
			FontColour: fontColour,
		}
        await UpdateAppearance(appearanceSettings, auth);
        window.location.reload();
    }

    if (loading) {
        return (
            <Dimmer inverted active={true}>
                <Loader inverted>Loading Appearance...</Loader>
            </Dimmer>
        );
    }

    const inputStyle = {
        marginLeft: 10
    }

    const onBgColClick = () => {
        //e.preventDefault();
        setBackgroundDisplay(!backgroundDisplay);
        setBackgroundColour(backgroundColour);
    }

    const onFontColClick = () => {
        setFontDisplay(!fontDisplay);
        setFontColour(fontColour);
    }

    return (
        <div className="ui admin-container" id="appearance-settings">
            <Grid>
                <Grid.Row style={{ marginLeft: "10px" }}>
                    <Grid.Column width={8}>
                        <div className="header blue headerStyleBlue">Colours</div>
                        <div className="header gray headerStyleGray">PRIMARY BACKGROUND COLOUR</div>
                        <div style={inputStyle} className='inputs'>
                            <div className="ui input">
                                <input type="text" placeholder={backgroundColour} style={{ backgroundColor: backgroundColour }} />
                                <Button id="prm-bck-col" className='buttton' onClick={onBgColClick} style={{ cursor: 'pointer', marginLeft: '10px' }}>Pick Colour</Button>
                            </div>
                            {backgroundDisplay && (
                                <div id="colour-picker">
                                    <ChromePicker color={backgroundColour} disableAlpha={true} onChange={(color, event) => { setBackgroundColour(color.hex) }} />
                                </div>
                            )}

                        </div>

                        <div className="header gray headerStyleGray">PRIMARY FONT COLOUR</div>
                        <div style={inputStyle} className='inputs'>
                            <div className="ui input">
                                <input type="text" placeholder={fontColour} style={{ backgroundColor: fontColour }} />
                                <Button id="prm-font-col" className='buttton' onClick={onFontColClick} style={{ cursor: 'pointer', marginLeft: '10px' }}>Pick Colour</Button>
                            </div>
                            {fontDisplay && (<div id="colour-picker"><ChromePicker color={fontColour} disableAlpha={true} onChange={(color, event) => { setFontColour(color.hex) }} /></div>)}

                        </div>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <div>
                            <div className="header blue headerStyleBlue">Logo</div>
                            <div className="header gray headerStyleGray">UPLOAD LOGO</div>
                            <div id="logo-section" >
                                <Grid style={{ marginLeft: "40px" }}>
                                    <Grid.Row>
                                        <UploadImage auth={auth} image={logo} name="Logo" key="uploadLogo" />
                                    </Grid.Row>
                                </Grid>
                            </div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "left", alignContent: "stretch", margin: 10, marginLeft:"20px" }}>
                <Button id="appearance-save" style={{ marginTop: 20 }} onClick={saveSettings}>Save</Button>
                <Button id="appearance-cancel" style={{ marginTop: 20, marginLeft: 5 }} onClick={getAppearanceSettings}>Cancel</Button>
            </div>
        </div>
    );
}

export default Appearance;